<template lang="pug">
  .page.special-page(
    @scroll="scrollEvent"
  )
    .special-page__bg
      img(src="videos/newyear-full2.gif")
      //- img(src="@/assets/images/bg/bg-image.jpg")
      //- video(
        src="videos/newyear.mp4"
        type="video/mp4"
        autoplay
        loop   )
    header.special-page__header.js-main-header
      main-header(
      :mode="'white'"
      :show-lang="true"
      @onCloseModal="closeModal"
      @onClickLogo="onChangeActiveSlide(0)"
      )
    main.special-page__main(
      v-if="onShowContent()"
    )
      .events-boxes
        .events-box.events-info
          .events-info__date(
          v-if="activeSlide === 0"
          ) {{translation.events_info.date}}
          .events-info__title {{ mainTitle }}
          .events-info__desc(
          v-if="activeSlide !== 0"
          ) {{ translation.events_info.slides[activeSlide].info }}
          .events-info__actions
            h1(style="color:white;") ЗАЯВКИ НЕ ПРИНИМАЮТСЯ
        .events-box.events-nav
          .events-nav__list
            .custom-scroll(
              :class="getClass()"
            )
            ul
              li(
                :class="{ 'active-event' : activeSlide === 1 }"
                @click="onChangeActiveSlide(1)"
              ) {{translation.events_info.slides[1].desc}}
              li(
                :class="{ 'active-event' : activeSlide === 2 }"
                @click="onChangeActiveSlide(2)"
              ) {{translation.events_info.slides[2].desc}}
              li(
                :class="{ 'active-event' : activeSlide === 3 }"
                @click="onChangeActiveSlide(3)"
              ) {{translation.events_info.slides[3].desc}}
    footer(

    )
      .footer__contacts
        .contacts-box
          ul.contacts__list
            li.contacts__item ул. Сафьян, д.5, Казань,
            li.contacts__item Респ. Татарстан, 420021
            li.contacts__item
              a(href="http://minmol.tatarstan.ru/" target="_blank") minmol.tatarstan.ru
        .contacts-box
          ul.contacts__list
            li.contacts__item e-mail:
              a(href="mailto:mcrt.org@gmail.com") mcrt.org@gmail.com
            li.contacts__item
              a(href="tel:+78432318119") 8 (843) 231-81-19
            li.contacts__item
              a(href="tel:+78432318129") 8 (843) 231-81-29
      .footer__links
        social-networks
</template>

<script>
import { mapActions, mapState } from "vuex";
import MainHeader from "../../components/main-header/main-header";
import MainFooter from "../../components/main-footer/main-footer";
import SocialNetworks from "../../components/social-networks/social-networks";

export default {
  name: "SpecialPage",
  components: { MainFooter, MainHeader, SocialNetworks },
  data() {
    return {
      curentPage: "special",
      touchEvent: null,
      currentEvent: {},
      contentMarginTop: "",
      contentMarginBottom: "",
      opacity: true,
      showModal: false,
      modalMode: "",
      modalData: null,
      customDate: "25 декабря",
      photos: [],
      activeSlide: 0,
      slideInterval: null,
      // data: [
      //   {
      //     id: 0,
      //     title: "Республиканская Новогодняя Елка 2020",
      //     desc:
      //       "Республиканская Новогодняя Елка 2020 в Ледовом дворце спорта «Татнефть Арена»",
      //     info:
      //       "Вот уже девятнадцатый год в нашей Республике в конце декабря проводится Республиканская новогодняя елка.  Это одно из самых крупных и значимых мероприятий в предновогодний период. Личное поздравление и пожелание детям и молодежи Президента Республики Татарстан, вручение новогодних подарков от его имени – одна из самых значимых форм поощрения детей и молодежи по итогам года. Данное мероприятие является единственным в своем роде, имеет большой резонанс среди общественности, широко освещается в средствах массовой информации."
      //   },
      //   {
      //     id: 1,
      //     title: "Световое и музыкальное шоу",
      //     desc: "Сказочное музыкальное шоу и незабываемые эмоции",
      //     info:
      //       "Множество героев из любимых сказок и мультфильмов появятся на сцене.  В этот вечер все юные зрители получат незабываемые впечатления от шоу на льду, живой музыки и конечно же встретят Деда Мороза и Снегурочку."
      //   },
      //   {
      //     id: 2,
      //     title: "Елка для самых-самых",
      //     desc:
      //       "Более 7000 юных зрителей из разных районов и городов Татарстана",
      //     info:
      //       "На елку приглашаются особенные дети: отличники учебы, лидеры детских общественных объединений, победители предметных олимпиад и спортивных соревнований, а также дети с ограниченными возможностями здоровья, дети-сироты и маленькие жители детских домов."
      //   },
      //   {
      //     id: 3,
      //     title: "Новогодние подарки",
      //     desc: "Каждый гость получит традиционные новогодние подарки",
      //     info:
      //       "Всем участникам республиканской новогодней елки будут вручены новогодние подарки от Президента Республики."
      //   }
      // ]
    };
  },
  computed: {
    ...mapState(["userData", "userAwards", "translation"]),
    mainTitle() {
      if (this.activeSlide === 0) {
        return this.translation.events_info.slides[this.activeSlide].desc;
      }
      return this.translation.events_info.slides[this.activeSlide].title;
    },
  },
  methods: {
    ...mapActions(["getCurrentEvent"]),
    closeModal() {
      this.showModal = false;
    },
    onShowContent() {
      if (this.showModal && this.modalMode === "notification-event") {
        return false;
      }
      return true;
    },
    scrollTouchEventStart(e) {
      this.touchEvent = e.touches[0].clientY;
    },
    scrollTouchEventEnd(e) {
      let touchEvent = e.changedTouches[0].clientY;
      if (touchEvent == this.touchEvent) {
        //        console.log("=");
      } else {
        //        console.log("!=");
        if (this.slideInterval === null) {
          if (this.touchEvent > touchEvent + 50 && this.activeSlide < 3) {
            this.activeSlide += 1;
          } else if (
            this.touchEvent < touchEvent + 50 &&
            this.activeSlide > 0
          ) {
            this.activeSlide -= 1;
          }
          this.slideInterval = setInterval(() => {
            clearInterval(this.slideInterval);
            this.slideInterval = null;
          }, 300);
        }
      }
    },
    scrollEvent(e) {
      if (this.slideInterval === null) {
        if (e.deltaY > 0 && this.activeSlide < 3) {
          this.activeSlide += 1;
        } else if (e.deltaY < 0 && this.activeSlide > 0) {
          this.activeSlide -= 1;
        }
        this.slideInterval = setInterval(() => {
          clearInterval(this.slideInterval);
          this.slideInterval = null;
        }, 300);
      }
    },
    onChangeActiveSlide(num) {
      this.activeSlide = Number(num);
    },
    getClass() {
      if (this.activeSlide === 1) {
        return "custom-scroll__top";
      } else if (this.activeSlide === 2) {
        return "custom-scroll__middle";
      } else if (this.activeSlide === 3) {
        return "custom-scroll__bottom";
      }
      return "";
    },
    getData() {
      this.getCurrentEvent().then((res) => {
        this.currentEvent = res.length > 0 ? res[0] : {};
        setTimeout(this.buildContent, 0);
      });
    },
    calcContentMargin() {
      // let windowHeight = window.innerHeight
      // let contentHeader = document.querySelector(".js-content-header");
      // let contentHeaderHeight = contentHeader.offsetHeight;
      // let contentHeaderMarginBottom = parseInt(getComputedStyle(contentHeader).marginBottom)
      // let contentFooterHeight = document.querySelector(".js-content-footer").offsetHeight;
      // this.contentMarginTop = (windowHeight - contentHeaderHeight - contentHeaderMarginBottom) + "px"
      // this.contentMarginBottom = (windowHeight / 2 - contentFooterHeight / 2) + "px"
    },
    buildContent() {
      this.setPhotos();
      this.setCustomDate();
      this.calcContentMargin();
      this.opacity = false;
    },
    changeModalMode(mode) {
      this.modalMode = mode;
    },
    setModalData() {
      return {
        date_time: this.translation.events_info.date,
        title: this.translation.events_info.modal_title,
        address: this.translation.events_info.address,
        id: this.currentEvent.id,
      };
    },
    setShowModal() {
      if (this.userData) {
        if (!this.userData.last_name) {
          this.showModal = true;
          this.modalMode = "check-profile";
          this.$root.$emit("onOpenModal", "check-profile");
        } else if (
          !this.userData.is_accompanying &&
          (!this.userAwards || this.userAwards.length === 0)
        ) {
          this.showModal = true;
          this.modalMode = "add-portfolio";
          this.$root.$emit("onOpenModal", "add-portfolio");
        } else {
          this.showModal = true;
          this.modalMode = "ordering";
          this.$root.$emit("onOpenModal", "ordering", this.setModalData());
        }
      } else {
        this.showModal = true;
        this.modalMode = "sign-in";
        this.$root.$emit("onOpenModal", "sign-in");
      }
    },
    setShowModalEventInfo() {
      this.showModal = true;
      this.modalMode = "notification-event";
      this.modalData = this.translation.events_info.slides[this.activeSlide];
      this.modalData.buttonText = "Подать заявку на участие";
      this.modalData.orderingModalData = this.setModalData();
      this.$root.$emit("onOpenModal", "notification-event", this.modalData);
    },
    setCustomDate() {
      let date = new Date(this.currentEvent.date_time);
      let day = date.getDate();
      let month = date.getMonth();
      let monthList = [
        "Января",
        "Февраля",
        "Марта",
        "Апреля",
        "Мая",
        "Июня",
        "Июля",
        "Августа",
        "Сентября",
        "Октября",
        "Ноября",
        "Декабря",
      ];
      let customMonth = monthList[month];
      let year = date.getFullYear();
      this.customDate = day + " " + customMonth + " " + year + " года";
    },
    changeSlide(e) {
      this.activeSlide = parseInt(e.target.value);
    },
    setPhotos() {
      this.currentEvent.photos = [];
      this.currentEvent.photos.length = 3;
      this.photos = this.currentEvent.photos.map((photo) => {
        return photo.file;
      });
    },
  },
  mounted() {
    this.getData();
    document.body.addEventListener("wheel", (e) => {
      this.scrollEvent(e);
    });
    document.body.addEventListener("touchstart", (e) => {
      this.scrollTouchEventStart(e);
    });
    document.body.addEventListener("touchend", (e) => {
      this.scrollTouchEventEnd(e);
    });
  },
  beforeDestroy() {
    document.body.removeEventListener("wheel", () => {
      this.scrollEvent();
    });
    document.body.removeEventListener("touchstart", () => {
      this.scrollTouchEventStart();
    });
    document.body.addEventListener("touchend", () => {
      this.scrollTouchEventEnd();
    });
  },
};
</script>
